import type {PerkIntegrationConfigComponentProps} from '@cohort/merchants/apps';
import ConnectionPicker from '@cohort/merchants/components/connections/ConnectionPicker';

const DiscordPrivateAccessPerkIntegrationConfigComponent: React.FC<
  PerkIntegrationConfigComponentProps
> = ({formReturn: {register, control}}) => {
  return (
    <div className="space-y-6">
      <ConnectionPicker appId="discord" register={register} control={control} />
    </div>
  );
};

export default DiscordPrivateAccessPerkIntegrationConfigComponent;
